export type ActivityTone = 'success' | 'warning' | 'error' | 'neutral';

export type User = {
  id: string;
  fullName: string;
  roles: string[];
};

export type ActivityLog = {
  id: string;
  type?: ActivityLogType | null;
  actionType?: ActivityLogActionType | null;
  initiator?: User | null;
  details?: string | null;
  startDate?: string | null;
  duration?: number | null;
  status?: string | null;
  activityId?: string | null;
  externalId?: string | null;
};

export enum ActivityLogActionType {
  FEEDBACK = 'FEEDBACK',
  MEANINGFUL_FEEDBACK = 'MEANINGFUL_FEEDBACK',
  CHANGE_COURSE = 'CHANGE_COURSE',
  CHANGE_MENTOR = 'CHANGE_MENTOR',
  CHANGE_STATUS = 'CHANGE_STATUS',
  MOVE_IN_PROGRAM = 'MOVE_IN_PROGRAM',
}

export enum ActivityLogType {
  ACTIVITY_PRACTICE = 'ACTIVITY_PRACTICE',
  ACTIVITY_LESSON = 'ACTIVITY_LESSON',
  ACTIVITY_CHAT = 'ACTIVITY_CHAT',
  ACTIVITY_EXERCISE = 'ACTIVITY_EXERCISE',
  ACTIVITY_POLL = 'ACTIVITY_POLL',
  CHAT = 'CHAT',
  EXERCISE = 'EXERCISE',
  LESSON = 'LESSON',
  POLL = 'POLL',
  PRACTICE = 'PRACTICE',
  MENTOR_FORM = 'MENTOR_FORM',
}

export type PracticeFeedbackPayload = {
  isDismiss?: boolean;
};

export type ActivityDetails = {
  name: string;
  date: string;
  status: string;
  passedAt: string | null;
  course: string;
  skill: string;
  hasFeedback: boolean;
  isFeedbackDismissed: boolean;
};
